// extracted by mini-css-extract-plugin
export default {"root":"z6Cc8","text":"j9uQu","icon":"ljQyb","active":"ns_ue"};